module.exports = __webpack_public_path__ + "static/media/tiktok.e038c877.png";